import {config} from 'core/config';
import Collapse from 'bootstrap/js/dist/collapse';

export function collapseSideFilter() {
    const $sideFilter = document.querySelector('#collapseSideFilter');
    if ($sideFilter !== null) {
        const sideFilterInstance = Collapse.getOrCreateInstance($sideFilter, {toggle: false});

        if (window.innerWidth < config.breakpoints.md) {
            sideFilterInstance.hide();
        } else {
            sideFilterInstance.show();
        }
    }
};
